import { useState, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../assets/logo2.png";
import { IoMdArrowDropleft } from "react-icons/io";
import { MdLocationOn, MdLocalPhone, MdPrint, MdEmail } from "react-icons/md";

import { Img } from "../components/Elements";
import { AppContext } from "../Context";

import "./css/footer.css";

export default function Footer() {
    const { t } = useTranslation();
    const params = useParams();
    const { userData, siteData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;
    const [data, setdata] = siteData;

    let site = data?.cats?.filter((r) => r?.name == params?.id);
    site = site?.length ? site[0] : {};

    return (
        <>
            <footer>
                <div className="mainWidth">
                    <nav className="links">
                        <strong>روابط</strong>
                        {site?.menu?.map((v, k) => {
                            if (!v?.sub?._id) {
                                return (
                                    <Link key={k} to={v?.link}>
                                        <IoMdArrowDropleft /> {v?.name}
                                    </Link>
                                );
                            }
                        })}
                    </nav>

                    <nav className="links">
                        <strong>روابط اخرى</strong>
                        {data?.cats?.map((v, k) => {
                            if (!v?.status?._id) return;
                            return (
                                <a key={k} href={`/site/${v?.name}`}>
                                    <IoMdArrowDropleft /> {v?.name}
                                </a>
                            );
                        })}
                    </nav>

                    <nav style={{ flex: 1 }}></nav>

                    <div className="contactBox">
                        <Img
                            className="logo"
                            src={site?.logo?.length ? site?.logo[0] : ""}
                        />
                        <label>
                            <MdLocationOn />
                            {t("footer_address")}
                        </label>
                        <label>
                            <MdLocalPhone /> {t("footer_phones")}
                        </label>
                        {/* <label>
                            <MdPrint /> {t("footer_fax")}
                        </label> */}
                        <label>
                            <MdEmail /> {t("footer_email")}
                        </label>
                    </div>
                </div>
            </footer>

            <div className="buildBy">
                Designed & developed by{" "}
                <a target="_blank" href="https://www.iblox.net/">
                    IBlox
                </a>
            </div>
        </>
    );
}
